function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getCurrentUser, logoutUser } from '@/actions/UserActions';
import React from 'react';
import { useNavigate, useOutlet } from 'react-router';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { HTTPError } from '@/utils/api';
import { getChannels, updateChannel } from '@/actions/ChannelActions';
import useHydrated from '@/hooks/useHydrated';
import useLoginRedirect from '@/hooks/useLoginRedirect';
import { useShallow } from 'zustand/react/shallow';
function AuthenticationProvider(param) {
    var children = param.children;
    var navigate = useNavigate();
    var isHydrated = useHydrated(useAuthenticationStore);
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            accessToken: state.accessToken,
            unverified2FA: state.unverified2FA,
            isLoggedIn: state.isLoggedIn,
            setLoggedIn: state.setLoggedIn
        };
    })), accessToken = _useAuthenticationStore.accessToken, unverified2FA = _useAuthenticationStore.unverified2FA, isLoggedIn = _useAuthenticationStore.isLoggedIn, setLoggedIn = _useAuthenticationStore.setLoggedIn;
    var outlet = useOutlet();
    var redirectLogin = useLoginRedirect();
    React.useEffect(function() {
        if (isLoggedIn || !isHydrated || unverified2FA) {
            return;
        }
        if (accessToken == null) {
            logoutUser();
            return;
        }
        getCurrentUser().then(function() {
            setLoggedIn(true);
            getChannels();
            updateChannel();
        }).catch(function(error) {
            if (_instanceof(error, HTTPError) && error.statusCode === 401) {
                logoutUser();
                redirectLogin();
            }
        });
    }, [
        accessToken,
        isLoggedIn,
        isHydrated,
        navigate,
        setLoggedIn,
        redirectLogin,
        unverified2FA
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: outlet !== null && outlet !== void 0 ? outlet : children
    });
}
export default AuthenticationProvider;
